import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { Container, ErrorMessage, PageHeader } from '../../common';
import SpecialistForm from './SpecialistForm';
import SpecialistDetails from './SpecialistDetails';

const Error = styled(ErrorMessage)`
  margin-bottom: 10px;
`;

class SpecialistPage extends React.Component {
  state = {
    isEditing: false,
    loadingError: '',
  };

  componentDidMount() {
    this.props.onMount().catch(error => this.setState({ loadingError: error }));
  }

  handleEdit = () => {
    this.setState({
      isEditing: true,
    });
  };

  handleCancel = () => {
    this.setState({
      isEditing: false,
    });
  };

  render() {
    const { isLoading, onContinue, onSave, specialists } = this.props;
    const { isEditing, loadingError } = this.state;
    const shouldShowForm = (isEmpty(specialists) && !isLoading) || isEditing;

    return (
      <Container>
        <PageHeader
          onEdit={this.handleEdit}
          shouldShowEdit={!shouldShowForm}
          title="Specialists"
        />
        {!!loadingError && <Error>{loadingError}</Error>}
        {!!isLoading && isEmpty(specialists) ? (
          <div>Loading...</div>
        ) : shouldShowForm ? (
          <SpecialistForm
            isEditing={isEditing}
            onCancel={this.handleCancel}
            onContinue={onContinue}
            onSave={onSave}
            specialists={specialists}
          />
        ) : (
          specialists.map(specialist => (
            <SpecialistDetails
              {...specialist}
              key={specialist.id || specialist.tempId}
            />
          ))
        )}
      </Container>
    );
  }
}

SpecialistPage.propTypes = {
  onContinue: PropTypes.func.isRequired,
  onMount: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  specialists: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      tempId: PropTypes.string,
    }),
  ),
};

export default SpecialistPage;



// WEBPACK FOOTER //
// ./src/modules/SpecialistPage/components/SpecialistPage.js